import React, { createContext, useState, useEffect, useContext } from 'react';

const minResponsiveWidth = 720;

interface IsMobileContextType {
  isMobile: boolean;
}

const IsMobileContext = createContext<IsMobileContextType | undefined>(undefined);

export const IsMobileProvider =  ({ children = null }: React.PropsWithChildren) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= minResponsiveWidth);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= minResponsiveWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return <IsMobileContext.Provider value={{ isMobile }}>{children}</IsMobileContext.Provider>;
};

export const useIsMobile = () => {
  const context = useContext(IsMobileContext);
  if (context === undefined) {
    throw new Error('useIsMobileContext must be used within an IsMobileProvider');
  }
  return context;
};
